import React from 'react'

import classnames from 'classnames'

import * as VoiceAI from './VoiceAI.types'
import { ChatHistoryMessage } from './useChatHistory'

const ChatBubble: React.FC<{ message: ChatHistoryMessage }> = ({ message }) => {
  if (message.event !== 'text') {
    return null
  }

  const textMessage = message as unknown as VoiceAI.TextMessage &
    ChatHistoryMessage

  return (
    <div className={classnames('chatBubble', textMessage.from)}>
      {textMessage.text.content}
    </div>
  )
}

export default ChatBubble
